/**
 * react-flow `nodeTypes` registry, keyed by `Component.kind`.
 *
 * Every kind in the IR's `ComponentKind` enum maps to either a
 * dedicated symbol or the GenericNode fallback. The registry is plain
 * so the consumer can extend it (e.g. a future TestPointNode) without
 * touching the dispatch table.
 */
import type { NodeTypes } from "@xyflow/react";

import { CapacitorNode } from "./CapacitorNode";
import { DiodeNode } from "./DiodeNode";
import { GenericNode } from "./GenericNode";
import { ICNode } from "./ICNode";
import { InductorNode } from "./InductorNode";
import { ResistorNode } from "./ResistorNode";

export const circuitNodeTypes: NodeTypes = {
  resistor: ResistorNode,
  capacitor: CapacitorNode,
  inductor: InductorNode,
  diode: DiodeNode,
  // Anything with a multi-pin body uses the IC chassis.
  ic: ICNode,
  opamp: ICNode,
  mosfet: ICNode,
  bjt: ICNode,
  // Connectors / sources / power rails / catch-all → generic.
  header: GenericNode,
  source: GenericNode,
  rail: GenericNode,
  other: GenericNode,
};
